import { useContext } from 'react'
import { FeatureFlagsContext } from '@fs/zion-flags'

// put here for easier mocking in tests
export default function useDynamicNavigationFlagContext() {
  return useContext(FeatureFlagsContext).flagOverrides
}
